import { createContext } from 'react';

export const PaymentContext = createContext(null);

export const GameContext = createContext(null);

export const ViewContext = createContext(null);
